import styled from 'styled-components';

import { GlobalToken } from 'antd';

export const Container = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-grow: 0;
  justify-content: space-between;
  align-items: center;
  width: 70px;
  height: 100%;
  padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingSM}px;
  box-sizing: border-box;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  position: relative;
  z-index: 10;

  .top {
    text-align: center;

    ul.top-menu {
      li {
        margin-top: ${({ theme: { token } }) => token.marginMD}px;

        &:first-child {
          margin-top: 0;
        }

        &.logo-container {
          padding: ${({ theme: { token } }) => token.padding}px 0;

          img {
            width: 50%;
          }
        }

        .icon {
          margin: auto;
        }

        .icon-engine {
          width: 32px;
          height: 32px;
          margin: auto;
        }

        .icon-reports {
          margin: auto;
          fill: ${({ theme: { token } }) => token.colorText};
          &:hover {
            fill: ${({ theme: { token } }) => token.colorPrimary};
          }
        }

        .icon-installer {
          margin: auto;
          fill: ${({ theme: { token } }) => token.colorBorder};
          &:hover {
            fill: ${({ theme: { token } }) => token.colorPrimary};
          }
        }

        .label {
          font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
          margin-top: ${({ theme: { token } }) => token.marginXXS}px;
          text-transform: capitalize;
        }

        .active,
        &:hover {
          path {
            fill: ${({ theme: { token } }) => token.colorPrimary};
          }
          .icon-reports {
            #background {
              fill: ${({ theme: { token } }) => token.colorPrimary};
            }

            #gaps {
              fill: ${({ theme: { token } }) => token.colorBgElevated};
            }
          }
          .icon {
            #background {
              fill: ${({ theme: { token } }) => token.colorPrimary};
            }
          }
        }
      }
    }
  }

  .sidebar-bottom {
    display: flex;
    flex-direction: column;

    .active {
      path {
        fill: ${({ theme: { token } }) => token.colorPrimary};
      }
    }

    ul {
      li {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: ${({ theme: { token } }) => token.paddingXXS}px 0;

        &.end-of-alerts-indications {
          border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorder};
          margin-bottom: ${({ theme: { token } }) => token.margin}px;
        }
        &.showcase-switch {
          padding-top: ${({ theme: { token } }) => token.paddingSM}px;
        }
      }

      .ant-avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: transparent;
      }

      .ant-popover-open {
        svg {
          path {
            fill: ${({ theme: { token } }) => token.colorPrimary};
          }
        }
      }

      &:last-child {
        padding-bottom: 0;
      }

      .alert-indication-container {
        cursor: pointer;
        border-radius: 2px;
        display: inline-flex;
        width: 48px;
        height: 24px;
        margin-bottom: ${({ theme: { token } }) => token.marginMD}px;
        background-color: ${({ theme: { token } }) => token.colorBgBase};

        &.shutdown-alerts {
          color: ${({ theme: { token } }) => token.colorError};
        }

        &.service-alerts {
          color: ${({ theme: { token } }) => token.colorInfo};
        }

        &.warning-alerts {
          color: ${({ theme: { token } }) => token.colorWarning};
        }

        span.anticon {
          svg {
            width: 24px;
            height: 24px;
          }
        }

        .alerts-count-container {
          width: 24px;
          height: 24px;
          line-height: 26px;
          font-size: ${({ theme: { token } }) => token.fontSize}px;
          text-align: center;
          vertical-align: middle;
        }
      }
    }
  }

  .settings-icon {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;

    &:hover,
    &.active {
      path {
        fill: ${({ theme: { token } }) => token.colorPrimary};
      }
    }
  }
`;
